import React from 'react';
import './Welcome.scss';
import GreetingUser from '../GreetingUser';
import SuggestionGrid from '../SuggestionGrid';

const Welcome = () => {
    return (
        <div className="welcome-component">
            <GreetingUser />
            {}
        </div>
    );
};

export default Welcome;
